export const GET_SHOPPING = "GET_SHOPPING";
export const INSERT_SHOPPING = "INSERT_SHOPPING";
export const UPDATE_SHOPPING = "UPDATE_SHOPPING";
export const DELETE_SHOPPING = "DELETE_SHOPPING";
export const TOGGLE_SHOPPING_STATUS = "TOGGLE_SHOPPING_STATUS";

export const OPEN_SHOPPING_DIALOG = "OPEN_SHOPPING_DIALOG";
export const CLOSE_DIALOG = "CLOSE_DIALOG";
